"use client";

import React, { useEffect, useState } from "react";
import { useAppStore } from "@/store/useAppStore";
import { useAuth } from "@/hooks/useAuth";
import { StatCard } from "./StatCard";

export const SocialFeatures: React.FC = () => {
  const { user } = useAuth();
  const { userRank, streak, activeTab, gameMode, crowdBeats } =
    useAppStore();
  const [shouldShowCrowdBeats, setShouldShowCrowdBeats] = useState(false);

  useEffect(() => {
    setShouldShowCrowdBeats(
      Boolean(activeTab === "challenges" && gameMode === "crowd")
    );
  }, [activeTab, gameMode]);

  if (!user) {
    return null;
  }

  return (
    <div className="flex items-center space-x-2" id="score-display">
      <StatCard
        value={userRank ? `#${userRank}` : "Unranked"}
        label="Rank"
        color="yellow"
      />

      <StatCard
        value={streak > 0 ? `${streak}🔥` : "0"}
        label="Streak"
        color="orange"
      />

      {shouldShowCrowdBeats && (
        <StatCard
          value={`${crowdBeats}🎯`}
          label="Crowd Beats"
          color="teal"
        />
      )}
    </div>
  );
};
